// contexts/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { isAuthenticated, logout as authLogout, getAuthenticatedUser } from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Vérifier l'état d'authentification au chargement
    const checkAuthStatus = () => {
      const authenticated = isAuthenticated();
      const authenticatedUser = getAuthenticatedUser();
      
      setIsLoggedIn(authenticated);
      setUser(authenticatedUser);
      setLoading(false);
    };

    checkAuthStatus();
  }, []);

  const login = (username) => {
    setIsLoggedIn(true);
    setUser(username);
  };

  const logout = () => {
    authLogout();
    setIsLoggedIn(false);
    setUser(null);
  };

  const value = {
    isLoggedIn,
    user,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
